import React from 'react';
import { Alert } from 'antd';
import PropTypes from 'prop-types';
import styles from './styles.module.less';

const NotificationBadge = ({ text }) => (
  <Alert
    message={text}
    description={' '}
    type="info"
    showIcon
    className={styles.badge}
  />
);

NotificationBadge.propTypes = {
  text: PropTypes.string,
};

export default NotificationBadge;
